import request from '../../utils/request';

export interface IAgentToken {
  id: number;
  user_id: number;
  tenant_id: number;
  email: string;
  label: string;
  is_active: boolean;
  created_at: string;
  expires_at: string;
  last_used_at: string | null;
  created_by_user_id: number;
}

export interface IGenerateTokenResponse {
  id: number;
  token: string;
  email: string;
  label: string;
  is_active: boolean;
  created_at: string;
  expires_at: string;
}

class AgentTokenService {
  list = async (): Promise<IAgentToken[]> => {
    const res = await request({ url: '/ai-chat/agent-tokens', method: 'GET' });
    return res.data.body.data;
  };

  generate = async (email: string, label: string): Promise<IGenerateTokenResponse> => {
    const res = await request({
      url: '/ai-chat/agent-token',
      method: 'POST',
      data: { email, label },
    });
    return res.data.body.data;
  };

  revoke = async (id: number): Promise<void> => {
    await request({ url: `/ai-chat/agent-token/${id}`, method: 'DELETE' });
  };
}

export default new AgentTokenService();
